import BlueSkyImage from '@/assets/medbox-images/blue-sky.jpg';
import EmeraldLakeImage from '@/assets/medbox-images/emerald-lake.jpg';
import PineForestImage from '@/assets/medbox-images/pine-forest.jpg';
import RoseWaterImage from '@/assets/medbox-images/rose-water.jpg';
import LilacBlossomImage from '@/assets/medbox-images/lilac-blossom.jpg';

import ThankYouBlueSkyImage from '@/assets/medbox-images/thank-you/blue-sky.png';
import ThankYouEmeraldLakeImage from '@/assets/medbox-images/thank-you/emerald-lake.png';
import ThankYouPineForestImage from '@/assets/medbox-images/thank-you/pine-forest.png';
import ThankYouRoseWaterImage from '@/assets/medbox-images/thank-you/rose-water.png';
import ThankYouLilacBlossomImage from '@/assets/medbox-images/thank-you/lilac-blossom.png';

import PlasticBoxBlueSkyImage from '@/assets/medbox-images/plastic-box/blue-sky.jpg';
import PlasticBoxEmeraldLakeImage from '@/assets/medbox-images/plastic-box/emerald-lake.jpg';
import PlasticBoxPineForestImage from '@/assets/medbox-images/plastic-box/pine-forest.jpg';
import PlasticBoxRoseWaterImage from '@/assets/medbox-images/plastic-box/rose-water.jpg';
import PlasticBoxLilacBlossomImage from '@/assets/medbox-images/plastic-box/lilac-blossom.jpg';

import { HueEnum } from '../types/enums/hue';
import { IHueOption } from '../types/interfaces/hue';

export const hueOptionsList: IHueOption[] = [
    {
        id: HueEnum.EMERALD_LAKE,
        name: 'Emerald Lake',
        class: 'emerald-lake',
        src: EmeraldLakeImage,
        plasticBoxSrc: PlasticBoxEmeraldLakeImage,
        thankYouSrc: ThankYouEmeraldLakeImage,
        color: '#95E3E5'
    },
    {
        id: HueEnum.PINE_FOREST,
        name: 'Pine Forest',
        class: 'pine-forest',
        src: PineForestImage,
        plasticBoxSrc: PlasticBoxPineForestImage,
        thankYouSrc: ThankYouPineForestImage,
        color: '#3A6D71'
    },
    {
        id: HueEnum.BLUE_SKY,
        name: 'Blue Sky',
        class: 'blue-sky',
        src: BlueSkyImage,
        plasticBoxSrc: PlasticBoxBlueSkyImage,
        thankYouSrc: ThankYouBlueSkyImage,
        color: '#9BD4E8'
    },
    {
        id: HueEnum.ROSE_WATER,
        name: 'Rose Water',
        class: 'rose-water',
        src: RoseWaterImage,
        plasticBoxSrc: PlasticBoxRoseWaterImage,
        thankYouSrc: ThankYouRoseWaterImage,
        color: '#F6E4D8'
    },
    {
        id: HueEnum.LILAC_BLOSSOM,
        name: 'Lilac Blossom',
        class: 'lilac-blossom',
        src: LilacBlossomImage,
        plasticBoxSrc: PlasticBoxLilacBlossomImage,
        thankYouSrc: ThankYouLilacBlossomImage,
        color: '#C3CCF4'
    },
];
